Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var core = require('@material-ui/core');
var reactFeather = require('react-feather');
var MaterialTable = require('material-table');
var frontend = require('@ds-developer/frontend');
var AddBox = require('@material-ui/icons/AddBox');
var ArrowUpward = require('@material-ui/icons/ArrowUpward');
var Check = require('@material-ui/icons/Check');
var ChevronLeft = require('@material-ui/icons/ChevronLeft');
var ChevronRight = require('@material-ui/icons/ChevronRight');
var Clear = require('@material-ui/icons/Clear');
var DeleteOutline = require('@material-ui/icons/DeleteOutline');
var Edit = require('@material-ui/icons/Edit');
var FilterList = require('@material-ui/icons/FilterList');
var FirstPage = require('@material-ui/icons/FirstPage');
var LastPage = require('@material-ui/icons/LastPage');
var Remove = require('@material-ui/icons/Remove');
var SaveAlt = require('@material-ui/icons/SaveAlt');
var Search = require('@material-ui/icons/Search');
var ViewColumn = require('@material-ui/icons/ViewColumn');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var MaterialTable__default = /*#__PURE__*/_interopDefaultLegacy(MaterialTable);
var AddBox__default = /*#__PURE__*/_interopDefaultLegacy(AddBox);
var ArrowUpward__default = /*#__PURE__*/_interopDefaultLegacy(ArrowUpward);
var Check__default = /*#__PURE__*/_interopDefaultLegacy(Check);
var ChevronLeft__default = /*#__PURE__*/_interopDefaultLegacy(ChevronLeft);
var ChevronRight__default = /*#__PURE__*/_interopDefaultLegacy(ChevronRight);
var Clear__default = /*#__PURE__*/_interopDefaultLegacy(Clear);
var DeleteOutline__default = /*#__PURE__*/_interopDefaultLegacy(DeleteOutline);
var Edit__default = /*#__PURE__*/_interopDefaultLegacy(Edit);
var FilterList__default = /*#__PURE__*/_interopDefaultLegacy(FilterList);
var FirstPage__default = /*#__PURE__*/_interopDefaultLegacy(FirstPage);
var LastPage__default = /*#__PURE__*/_interopDefaultLegacy(LastPage);
var Remove__default = /*#__PURE__*/_interopDefaultLegacy(Remove);
var SaveAlt__default = /*#__PURE__*/_interopDefaultLegacy(SaveAlt);
var Search__default = /*#__PURE__*/_interopDefaultLegacy(Search);
var ViewColumn__default = /*#__PURE__*/_interopDefaultLegacy(ViewColumn);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var calculateSum = function calculateSum(values) {
  return values.reduce(function (total, value) {
    return total + value;
  }, 0);
};
var getDateRangeString = function getDateRangeString(range) {
  return frontend.formatDateShort(new Date(range.start)) + " \u2014 " + frontend.formatDateShort(new Date(range.end));
};
var tableIcons = {
  Add: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(AddBox__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Check: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Check__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Clear: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Clear__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Delete: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(DeleteOutline__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  DetailPanel: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronRight__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Edit: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Edit__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Export: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(SaveAlt__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Filter: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(FilterList__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  FirstPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(FirstPage__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  LastPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(LastPage__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  NextPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronRight__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  PreviousPage: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ChevronLeft__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ResetSearch: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Clear__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  Search: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Search__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  SortArrow: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ArrowUpward__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ThirdStateCheck: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(Remove__default['default'], _assign({}, props, {
      ref: ref
    }));
  }),
  ViewColumn: React.forwardRef(function (props, ref) {
    return React__default['default'].createElement(ViewColumn__default['default'], _assign({}, props, {
      ref: ref
    }));
  })
};
var useStyles = core.makeStyles(function (theme) {
  return {
    bold: {
      fontWeight: theme.typography.fontWeightBold
    }
  };
});
var TitleComponent = function TitleComponent(_a) {
  var title = _a.title;
  return React__default['default'].createElement(core.Table, null, React__default['default'].createElement(core.TableHead, null, React__default['default'].createElement(core.TableRow, null, React__default['default'].createElement(core.TableCell, null, React__default['default'].createElement(core.Typography, {
    variant: "h6"
  }, title)))));
};
var RowComponent = function RowComponent(_a) {
  var transactions = _a.transactions,
    isLastVisibleRow = _a.isLastVisibleRow,
    showSubtotalRow = _a.showSubtotalRow,
    range = _a.range,
    props = __rest(_a, ["transactions", "isLastVisibleRow", "showSubtotalRow", "range"]);
  var classes = useStyles();
  var subtotalRowShouldRender = isLastVisibleRow && showSubtotalRow && transactions;
  return React__default['default'].createElement(React.Fragment, null, React__default['default'].createElement(MaterialTable.MTableBodyRow, _assign({
    "data-test": "instructor-transactions-table-row"
  }, props)), subtotalRowShouldRender && React__default['default'].createElement(core.TableRow, {
    "data-test": "instructor-transaction-subtotal-row"
  }, React__default['default'].createElement(core.TableCell, {
    classes: {
      root: classes.bold
    }
  }, range ? getDateRangeString(range) : ""), React__default['default'].createElement(core.TableCell, {
    classes: {
      root: classes.bold
    }
  }, "SUB-TOTAL"), React__default['default'].createElement(core.TableCell, {
    classes: {
      root: classes.bold
    }
  }, React__default['default'].createElement("div", {
    "data-label": "Sub-total exc. VAT"
  }, frontend.formatCurrency(calculateSum(transactions.map(function (t) {
    return t.valueExVat;
  }))))), React__default['default'].createElement(core.TableCell, {
    classes: {
      root: classes.bold
    }
  }, React__default['default'].createElement("div", {
    "data-label": "Sub-total inc. VAT"
  }, frontend.formatCurrency(calculateSum(transactions.map(function (t) {
    return t.value;
  })))))));
};
var TransactionsTable = function TransactionsTable(_a) {
  var _b = _a.loading,
    loading = _b === void 0 ? false : _b,
    _c = _a.transactions,
    transactions = _c === void 0 ? [] : _c,
    title = _a.title,
    _d = _a.showActions,
    showActions = _d === void 0 ? true : _d,
    showSubtotalRow = _a.showSubtotalRow,
    _e = _a.onDelete,
    onDelete = _e === void 0 ? function () {} : _e,
    range = _a.range;
  var theme = core.useTheme();
  var tableRef = React.useRef(null);
  var className = showActions ? "mobile-friendly has-actions" : "mobile-friendly";
  return React__default['default'].createElement(core.Box, {
    className: className,
    margin: 0
  }, React__default['default'].createElement(MaterialTable__default['default'], {
    title: "Action Overriding Preview",
    icons: tableIcons,
    isLoading: loading,
    tableRef: tableRef,
    columns: [{
      title: "Date",
      field: "date",
      sorting: false,
      render: function render(rowData) {
        return React__default['default'].createElement("div", {
          "data-label": "Date"
        }, frontend.formatDateShort(rowData.date));
      }
    }, {
      title: "Reference",
      field: "reference",
      sorting: false,
      render: function render(rowData) {
        return React__default['default'].createElement("div", {
          "data-label": "Reference"
        }, rowData.reference);
      }
    }, {
      title: "Value (exc VAT)",
      field: "value",
      sorting: false,
      render: function render(rowData) {
        return React__default['default'].createElement("div", {
          "data-label": "Value (exc VAT)"
        }, frontend.formatCurrency(rowData.valueExVat, false));
      }
    }, {
      title: "Value (inc VAT)",
      field: "value",
      sorting: false,
      render: function render(rowData) {
        return React__default['default'].createElement("div", {
          "data-label": "Value (inc VAT)"
        }, frontend.formatCurrency(rowData.value, false));
      }
    }],
    actions: showActions ? [function (rowData) {
      return {
        icon: function icon() {
          return React__default['default'].createElement(reactFeather.Trash2, null);
        },
        onClick: function onClick(_event, ledgerItem) {
          if (Array.isArray(ledgerItem)) {
            return;
          }
          if (ledgerItem) {
            onDelete(ledgerItem.id);
          }
        },
        hidden: !rowData.isCancellable,
        tooltip: "Delete transaction"
      };
    }] : [],
    options: {
      actionsCellStyle: {
        justifyContent: "center"
      },
      paging: true,
      pageSize: 10,
      searchFieldAlignment: "left",
      searchFieldStyle: {
        marginLeft: theme.spacing(2)
      },
      emptyRowsWhenPaging: false,
      actionsColumnIndex: -1
    },
    localization: {
      body: {
        emptyDataSourceMessage: "No transactions to display" + (range ? " for date range " + getDateRangeString(range) : "")
      }
    },
    components: _assign(_assign({}, transactions.length ? {} : {
      Header: function Header() {
        return null;
      }
    }), {
      Toolbar: function Toolbar() {
        return title ? React__default['default'].createElement(TitleComponent, {
          title: title
        }) : null;
      },
      Container: function Container(props) {
        return React__default['default'].createElement(core.Paper, _assign({}, props, {
          elevation: 0
        }));
      },
      Row: function Row(props) {
        var _a, _b;
        return React__default['default'].createElement(RowComponent, _assign({
          transactions: transactions,
          isLastVisibleRow: ((_b = (_a = tableRef.current) === null || _a === void 0 ? void 0 : _a.dataManager) === null || _b === void 0 ? void 0 : _b.pageSize) === props.index + 1 || transactions.length === props.index + 1,
          showSubtotalRow: showSubtotalRow,
          range: range
        }, props));
      }
    }),
    data: transactions
  }));
};
exports.default = TransactionsTable;